export default __webpack_public_path__ + "icon-social-media-blog-rollover.afd36395df6b25bccb17.svg";